import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class PdpInteractionApplicationEvent implements ApplicationEvent {
  type = this.action;

  constructor(private action: ApplicationEventType, private label: string) {}

  getPayload(): any {
    return {
      category: ApplicationEventType.Interaction,
      action: this.action,
      label: this.label
    };
  }
}
